import CommunityProfileSettingsPage from './CommunityProfileSettingsPage'

export default CommunityProfileSettingsPage
